import React, { useContext } from "react";
import { ProductContext } from "../contexts/ProductContext";
import Product from "../components/Product";
import Header from "../components/Header";
import Footer from "../components/Footer";
// import Hero from "../components/Hero";

const Home = () => {
  // Retrieve the products from the Product Context
  const { products } = useContext(ProductContext);

  console.log(products);

  // Example filtering: Only products categorized as "Product"
  const filteredProducts = products.filter(
    (item) =>
      item.category === "Product" ||
      item.category === "Service" ||
      item.category === "product" ||
      item.category === "service"
  );

  return (
    <div>
      <Header />
      {/* <Hero /> */}
      <div className="pt-[40px] lg:pt-[40px]">
        <section className="py-20">
          <div className="container mx-auto">
            <h1 className="text-3xl font-semibold mb-10 text-center">
              Our Products
            </h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 lg:mx-8 gap-[30px] max-w-sm mx-auto md:max-w-none md:mx-0">
              {filteredProducts.map((product) => (
                <Product product={product} key={product.id} />
              ))}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
